{
  "version": 1,
  "asset_id": "ea8a9286-1be3-49ec-97f7-023845121cbf",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/ea8a9286-1be3-49ec-97f7-023845121cbf/hiatal-type-2-v2-1536.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/ea8a9286-1be3-49ec-97f7-023845121cbf/hiatal-type-2-v2-1536.jpg",
  "original_filename": "hiatal-type-2-v2-1536.jpg",
  "size": 235526,
  "content_type": "image/jpeg",
  "created_at": "2026-09-24T19:25:17Z"
}
